import { render, staticRenderFns } from "./worksCom.vue?vue&type=template&id=ef56c3b6&scoped=true&"
import script from "./worksCom.vue?vue&type=script&lang=js&"
export * from "./worksCom.vue?vue&type=script&lang=js&"
import style0 from "./worksCom.vue?vue&type=style&index=0&id=ef56c3b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef56c3b6",
  null
  
)

export default component.exports